export const headerCellTitle = {
    flex: 1,
    paddingLeft: 40,
    minWidth: 0,
};

export const headerCellAssignee = {
    width: 240,
    borderRight: 'none',
    flexShrink: 0,
};
